import { Store } from '../State';
import * as ReactDOM from 'react-dom';
import { saveAppShellData } from '../AppShell/utils';
import { resolveThemeContext } from '../resolve-component';
import { exposeScopeState } from '../events';

export const scopeSiteContainerAttribute = 'avensia-scope-root';

export default async function browserRender(store: Store, container: Element, element: React.ReactElement<any>) {
  exposeScopeState(store);
  await (store.getState().currentTheme ? resolveThemeContext(store.getState().currentTheme) : Promise.resolve(null));
  container.setAttribute(scopeSiteContainerAttribute, 'true');
  await new Promise(resolve => {
    if (window.IS_SERVER_SIDE_RENDERED) {
      ReactDOM.hydrate(element, container, resolve);
    } else {
      ReactDOM.render(element, container, resolve);
    }
  });
  await saveAppShellData(store.getState().appShellData);
}
